import { MsgCategories, TICKETORDERCODE, TICKETORDERTYPE } from 'data/notification';
class Message {
    constructor () {
        this.unreadMap = {};
        this.unreadData = {};
        this.unreadMsgMap = {};
        this.userId = 0;
    }

    updateUnread(userId, data) {
        // 不同用户，清空单例消息，适用于登出重新登录
        if (this.userId !== userId) {
            this.userId = userId;
            this.unreadMsgMap = {};
        }
        // 以下拷贝自老项目otp，不是我写的
        let unreadData = data || [];
        let unreadMsgMap = {};

        let hasUnread = false;
        if (Array.isArray(unreadData)) {
            try {
                unreadData.forEach(categoryMsg => {
                    if (categoryMsg && categoryMsg.categoryCode && categoryMsg.msgTypeVOList) {
                        unreadMsgMap[categoryMsg.categoryCode] = categoryMsg.msgTypeVOList;
                    }
                });
                let msgs = this.unreadMsgMap && this.unreadMsgMap[TICKETORDERCODE] && this.unreadMsgMap[TICKETORDERCODE] || [];
                let ticketOrderMsg = msgs.find((msg) => {
                    return msg.typeId === TICKETORDERTYPE;
                });
                if (ticketOrderMsg) {
                    unreadMsgMap[TICKETORDERCODE].unshift(ticketOrderMsg);
                }
                for (let i = 0; i < MsgCategories.length; ++i) {
                    let categoryItem = MsgCategories[i];
                    let oldCategoryMsg = this.unreadMsgMap[categoryItem.id];
                    let newCategoryMsg = unreadMsgMap[categoryItem.id];
                    if (!newCategoryMsg) {
                        continue;
                    }
                    if (!oldCategoryMsg && newCategoryMsg) {
                        hasUnread = true;
                        break;
                    }
                    for (let j = 0; j < newCategoryMsg.length; ++j) {
                        let newTypeMsg = newCategoryMsg[j];
                        let oldTypeMsg = oldCategoryMsg.find(typeMsg => { return typeMsg.typeId === newTypeMsg.typeId; });
                        if (!newTypeMsg) {
                            continue;
                        }
                        if (!oldTypeMsg && newTypeMsg) {
                            hasUnread = true;
                            break;
                        }
                        if (oldTypeMsg.count < newTypeMsg.count) {
                            hasUnread = true;
                            break;
                        }
                    }
                    if (hasUnread) {
                        break;
                    }
                }
            } catch (ex) {
                console.error(ex);
            }
            this.unreadMsgMap = unreadMsgMap;
        } else {
            if (!this.unreadMsgMap) {
                this.unreadMsgMap = {};
            }
            let ticketOrderMsg = null;
            let msgs = this.unreadMsgMap && this.unreadMsgMap[TICKETORDERCODE] && this.unreadMsgMap[TICKETORDERCODE] || [];
            if (msgs.length) {
                ticketOrderMsg = msgs.find((msg) => {
                    return msg.typeId === TICKETORDERTYPE;
                });
            }
            if (!ticketOrderMsg) {
                ticketOrderMsg = { typeId: TICKETORDERTYPE, typeDesc: '待出票订单', typeWeight: 1, count: data.reserveOrderConfirm, checked: null };
                msgs.unshift(ticketOrderMsg);
                hasUnread = true;
            } else {
                if (ticketOrderMsg.count !== data.reserveOrderConfirm) {
                    ticketOrderMsg.count = data.reserveOrderConfirm;
                    hasUnread = true;
                }
            }
            this.unreadMsgMap[TICKETORDERCODE] = msgs;
            if (!data.reserveOrderConfirm && data.reserveOrderConfirm !== 0) {
                this.unreadMsgMap = Object.assign(this.unreadMsgMap, unreadData);
                hasUnread = true;
            }
            unreadMsgMap = this.unreadMsgMap;
        }
        if (hasUnread) {
            return unreadMsgMap;
        } else  {
            return false;
        }
    }
}

export default Message;


// WEBPACK FOOTER //
// ./src/store/modules/message.js